import { ProjectSourceDto } from "app/ApiClient";
import { LoadingState } from "types";

export interface ProjectSourcesState {
  projectSources?: ProjectSourceDto[];
  projectSourcesLoading: LoadingState;
}

export const defaultProjectsSourcesState: ProjectSourcesState = {
  projectSourcesLoading: LoadingState.idle,
  projectSources: [],
};
